export const money = (v) => {
  const n = Number(v || 0);
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

export const num = (v) => Number(v || 0).toLocaleString('en-US');

export const shortDate = (v) => {
  if (!v) return '-';
  try {
    return new Date(v).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch { return String(v).slice(0, 10); }
};

export const dateTime = (v) => {
  if (!v) return '-';
  try {
    return new Date(v).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch { return String(v).slice(0, 19); }
};
